export default __webpack_public_path__ + "static/media/map.ff47868b.png";